<template>
    <div
      :class="['modal', 'fade', 'show']"
      :style="{ display: 'block'}"
      id="incomingCallsModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="incomingCallsModalLabel"
      aria-hidden="true"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div
              class="spinner-grow text-muted d-inline mr-1 mt-3"
              role="status"
              style="width: 5px; height: 5px"
            >
              <span class="sr-only">Calling...</span>
            </div>
            <div
              class="spinner-grow text-muted d-inline mr-1 mt-3"
              role="status"
              style="width: 5px; height: 5px"
            >
              <span class="sr-only">Calling...</span>
            </div>
            <div
              class="spinner-grow text-muted d-inline mr-2 mt-3"
              role="status"
              style="width: 5px; height: 5px"
            >
              <span class="sr-only">Calling...</span>
            </div>
            <h5 class="modal-title d-inline" id="incomingCallsModalLabel" v-html="title">
            </h5>
            <button
              class="close"
              type="button"
              aria-label="Close"
              @click="rejectCall"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <font-awesome-icon
              :icon="['fas', 'user']"
              class="fa-2x text-primary d-inline"
            />
            <h3 class="d-inline text-primary pl-1">{{ user }}</h3>
            <p v-if="body">{{ body }}</p>
          </div>
          <div class="modal-footer">
            <button class="btn btn-success" type="button" @click="acceptCall">
              <font-awesome-icon :icon="['fas', 'phone']" /> Take
            </button>
            <button class="btn btn-warning" type="button" @click="rejectCall">
              <font-awesome-icon :icon="['fas', 'phone-slash']" /> Reject
            </button>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
    export default {
        name: 'IncomingCallDialog',
        props: ['title', 'body', 'user'],
        methods: {
            acceptCall() {
                this.$emit('accept_incoming_call');
            },
            rejectCall() {
                this.$emit('reject_incoming_call');
            }
        }
    }
</script>